import { queryOptions } from '@tanstack/react-query';
import { Domain, } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
export const vehicleKeys = {
    all: ['vehicles'],
    get: (filter, scope) => ['vehicles', filter, scope],
};
export const vehicleOptions = {
    get: (filter, scope) => queryOptions({
        queryKey: vehicleKeys.get(filter, scope),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.Vehicle);
            return repo.get(filter, scope);
        },
    }),
    create: () => ({
        mutationFn: async (requests) => {
            const repo = await resolveRepository(Domain.Vehicle);
            return repo.create(requests);
        },
    }),
    update: () => ({
        mutationFn: async (requests) => {
            const repo = await resolveRepository(Domain.Vehicle);
            return repo.update(requests);
        },
    }),
    remove: () => ({
        mutationFn: async (requests) => {
            const repo = await resolveRepository(Domain.Vehicle);
            return repo.remove(requests);
        },
    }),
    getOrCreate: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.Vehicle);
            return repo.getOrCreate(request);
        },
    }),
};
